export interface Staff {
    name: string;
    img: string;
    post: string;
}

export const StaffList: Staff[] = [
    {
        name: "Айрат Валитов",
        img: "/team/airat.webp",
        post: "Ген. директор",
    },
    {
        name: "Амир Валитов",
        img: "/team/amir.webp",
        post: "Инженер-конструктор",
    },
    {
        name: "Даниил Палабугин",
        img: "/team/daniil.webp",
        post: "Фронтендер",
    },
    {
        name: "Владислав Ахунов",
        img: "/team/vlados.webp",
        post: "Слесарь-сборщик и монтажник РЭАиП",
    },
    {
        name: "Владислав Удалов",
        img: "/team/vlad.webp",
        post: "Инженер-программист Регулировщик РЭАиП",
    },
    {
        name: "Марина Оганян",
        img: "/team/marina.webp",
        post: "UX/UI Дизайнер Графический дизайнер",
    },
    {
        name: "Богдан Галлямшин",
        img: "/team/bogdan.webp",
        post: "Инженер-программист",
    },
    {
        name: "Владислав Иванов",
        img: "/team/vlad2.webp",
        post: "Инженер-программист",
    },
    {
        name: "Георгий Егоров",
        img: "/team/egor.webp",
        post: "Старший инженер-программист",
    }
];